module.exports = "/images/laptop-stand-gift.jpg";